<template>
  <div>
    
    <v-btn v-show="imgData === null" elevation="2" @click="captureImage()"
      ><v-icon>mdi-monitor-screenshot</v-icon>Include Image of Map</v-btn
    >
    <v-btn elevation="2" @click="print()"
      ><v-icon>mdi-printer</v-icon>Print</v-btn
    >
    <div id="print-container">
      <div class="title print-title">
        <img class="print-cuny-logo" src="cuny-gc-logo.png"
        />
         <a class="print-cuny-link" href="https://www.gc.cuny.edu/CUR" target="_blank"
          >
          Application developed by the Center For Urban Research at the CUNY Graduate Center
          </a>
          <v-toolbar-title class="main-header"
            ><span class="year">Redistricting</span> &amp; You</v-toolbar-title
          >
          <!-- <v-toolbar-title class="subtitle">Current Districts &amp; Implications for Post-2020 Redistricting</v-toolbar-title> -->
          <v-toolbar-title class="subtitle"
            >Current Districts &amp; Implications for Post-2020
            Maps</v-toolbar-title
          >

          <v-toolbar-title class="subtitle sub-url"
            >redistrictingandyou.org</v-toolbar-title
          >
        </div>
      <SelectedDataDisplay style="margin-top: 25px" :printable="true" :imgData="this.imgData" />
    </div>
  </div>
</template>

<script>
import SelectedDataDisplay from "../../DataDisplay/SelectedDataDisplay";
export default {
  name: "ModalPrint",
  components: {
    SelectedDataDisplay,
  },
  data: function () {
    return {
      imgData: null,
    };
  },
  watch: {},
  methods: {
    captureImage() {
      let map = this.$store.getters.getMap;
      let canv = map.getCanvas();
      this.imgData = canv.toDataURL();
    },
    print() {
      this.$htmlToPaper("print-container", {
        styles: [
          "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
          "https://unpkg.com/kidlat-css/css/kidlat.css",
          "./print.css",
        ],
      });
    },
    clearImg() {
      this.imgData = null;
    },
  },
};
</script>
<style scoped>
.map-img {
  max-width: 100%;
}
.main-header {
      margin-left: 25px;
      margin-top: 7px;
  line-height: 1.125em;
}
.title-link {
  text-decoration: none;
}

.title-link .title {
  cursor: pointer !important;
}

.sub-url{
      position: absolute;
    display: inline-block;
    right: 0;
    bottom: 0;
    font-size: 1em;
}

.title {
  cursor: pointer;
  overflow: inherit;
  background: transparent;
  /* background: var(--tan); */
  height: 64px;
  padding: 23px 64px;
  padding-left: 16px !important;
  color: var(--prussian-blue);
  font-weight: 900;
  text-transform: uppercase;
  cursor: default;

}

.title .year {
  color: var(--imperial-red);
}

.subtitle {
  font-size: 70%;
  text-transform: initial;
  font-weight: initial;
      margin-left: 25px;
}
.v-tab--active {
  color: inherit;
}

header.top-toolbar-content {
  background: var(--honeydew) !important;
  /* background: var(--light-peach-puff) !important; */
}
</style>
<style>
#print-container {
  pointer-events: none !important;
}
#print-container .title button {
  display: none !important;
}
#print-container .title.district-state {
  padding-left: 0px;
}

#print-container .v-tabs {
  display: none;
}

#print-container > .legend {
  background-color: #fff;
  border-radius: 3px;
  bottom: 0px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  font: 12px/20px "Helvetica Neue", Arial, Helvetica, sans-serif;
  padding: 10px 22px;
  position: relative;
  right: 0px;
  z-index: 1;
}
.print-cuny-link{
  font-size: .5em;
    position: absolute;
    left: 0;
    text-align: left;
top: 0px;
}

.print-cuny-logo{
  position: absolute;
  left:0px;
}

#print-container .layer-toggle-container{
  margin: 0;
}

#print-container .data-note-btn-container,
#print-container > .legend > .slider-container,
#print-container > .legend > .slider-container *,
#print-container > .legend > button {
  display: none !important;
}
</style>